import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Matter } from '../../../features/requets/shared/matter.model';
import { MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef, MatPaginator, MatSort } from '@angular/material';
import { ProgramService } from '../../../features/programs/shared/program.service';

@Component({
  selector: 'app-select-subject-request-dialog',
  templateUrl: './select-subject-request-dialog.component.html',
  styleUrls: ['./select-subject-request-dialog.component.scss']
})
export class SelectSubjectRequestDialogComponent implements OnInit {

  displayedColumns: string[] = ['codigo', 'nombre', 'tipo', 'consecutivo', 'banco'];
  dataSource: MatTableDataSource<Matter>;
  selectedRowIndex = -1;
  SelectItem: Matter;
  expandedPanel = true;
  enabledSpinner = false;
  cedula: String;
  nombre: string;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
               private programService: ProgramService,
               public dialogRef: MatDialogRef<SelectSubjectRequestDialogComponent>) { }

ngOnInit() {

}

close() {
this.dialogRef.close(null);
}


  findSubject() {
    const cedulaParam = !this.cedula ? '' : this.cedula;
    const nombreParam = !this.nombre ? '' : escape(this.nombre.toUpperCase());
    this.enabledSpinner = true;
    this.programService.getSubjectByProgram(this.data.program, this.data.version, cedulaParam, nombreParam ).subscribe(
    (result) => {
        if (result.data as Matter[]) {

          this.dataSource = new MatTableDataSource(result.data);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.expandedPanel = false;
          this.enabledSpinner = false;
        }
      }
    );
  }

  highlight(row) {
    this.selectedRowIndex = row.codigo;
    this.SelectItem =  row;
 }

 sendSelect() {
  const data = { item: this.SelectItem };
  this.dialogRef.close(data);
 }
}
